import React from 'react';
import { AnimatedSkeletonLoader } from '@/components/animated-skeleton-loader';
import { SCREEN_PADDING, SCREEN_PADDING_SMALL } from '@/styles';
import { StyleSheet, View } from 'react-native';
import { useLayoutContext } from '@/contexts/layout-context';

export const OriginalInboundSkeleton: React.FC = () => {
  const { isSmallTabletLayout } = useLayoutContext();

  return (
    <View
      style={[
        styles.container,
        isSmallTabletLayout ? null : styles.extraSpacing,
      ]}
    >
      <AnimatedSkeletonLoader height={40} style={styles.restaurantSelector} />
      <View style={styles.messageContainer}>
        <AnimatedSkeletonLoader height={16} width="90%" />
        <AnimatedSkeletonLoader height={16} width="75%" />
        <AnimatedSkeletonLoader height={16} width="85%" />
      </View>
      <View style={styles.messageContainer}>
        <AnimatedSkeletonLoader height={16} width="80%" />
        <AnimatedSkeletonLoader height={16} width="70%" />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: SCREEN_PADDING_SMALL,
  },
  extraSpacing: {
    marginTop: SCREEN_PADDING,
  },
  messageContainer: {
    gap: 8,
    marginTop: 16,
  },
  restaurantSelector: {
    borderRadius: 8,
    marginBottom: 16,
  },
});
